var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("DetailItems", { attrs: { fields: _vm.fields, data: _vm.data } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }